import { setupLocale } from "../localizationManager";

export var italianStrings = {
  // "Group By Me"
  groupButton: "Raggruppa",
  // "Ungroup By Me"
  ungroupButton: "Dividi",
  // "Select Me"
  selectButton: "Selezionami",
  // "Hide column"
  hideColumn: "Nascondi colonna",
  // "Show column"
  showColumn: "Mostra colonna",
  // "Make column private"
  makePrivateColumn: "Rendi la colonna privata",
  // "Make column public"
  makePublicColumn: "Rendi la colonna pubblica",
  // "Move to Detail"
  moveToDetail: "Sposta in Dettaglio",
  // "Show as Column"
  showAsColumn: "Mostra come Colonna",
  // "Search..."
  filterPlaceholder: "Cerca...",
  // "Remove rows"
  removeRows: "Rimuovi righe",
  // "Show"
  showLabel: "Mostra",
  // "entries"
  entriesLabel: "voci",
  // "Texts in table"
  visualizer_text: "Parole in tabella",
  // "Wordcloud"
  visualizer_wordcloud: "Nuvola di parole",
  // "Histogram"
  visualizer_histogram: "Istogramma",
  // "Average"
  visualizer_number: "Media",
  // "Table"
  visualizer_choices: "Tabella",
  // "Chart"
  visualizer_selectBase: "Grafico",
  // [Auto-translated] "Chart"
  visualizer_matrix: "Tabella",
  // [Auto-translated] "Bar"
  chartType_bar: "Bar",
  // "Vertical Bar"
  chartType_vbar: "Grafico a barre verticali",
  // "Stacked Bar"
  chartType_stackedbar: "Grafico a barre sovrapposte",
  // "Doughnut"
  chartType_doughnut: "Grafico a ciambella",
  // "Pie"
  chartType_pie: "Grafico a torta",
  // "Scatter"
  chartType_scatter: "Grafico a dispersione",
  // "Gauge"
  chartType_gauge: "Grafico Gauge",
  // "Bullet"
  chartType_bullet: "Punto",
  // [Auto-translated] "Line"
  chartType_line: "Linea",
  // [Auto-translated] "Radar"
  chartType_radar: "Radar",
  // "Hide"
  hideButton: "Nascondi",
  // "Make private"
  makePrivateButton: "Rendi privato",
  // "Make public"
  makePublicButton: "Rendi pubblico",
  // "Show"
  showButton: "Mostra",
  // "Filter"
  filter: "Filtro",
  // "Reset Filter"
  resetFilter: "Cancella filtro",
  // "Change Locale"
  changeLocale: "Cambia lingua",
  // "Clear"
  clearButton: "Cancella",
  // "Choose question to show..."
  addElement: "Scegli la domanda da mostrare...",
  // "Default Order"
  defaultOrder: "Ordine di Default",
  // "Ascending"
  ascOrder: "Ascendente",
  // "Descending"
  descOrder: "Discendente",
  // "Show minor columns"
  showMinorColumns: "Mostra colonne secondarie",
  // [Auto-translated] "Actions"
  actionsColumn: "Azioni",
  // "Other items and comments"
  otherCommentTitle: "Altri punti e commenti",
  // "Show percentages"
  showPercentages: "Mostra percentuali",
  // "Hide percentages"
  hidePercentages: "Nascondi percentuali",
  // "PDF"
  pdfDownloadCaption: "PDF",
  // "Excel"
  xlsxDownloadCaption: "Excel",
  // "CSV"
  csvDownloadCaption: "CSV",
  // "Download plot as a PNG file"
  saveDiagramAsPNG: "Scarica il grafico in formato png",
  // "Hide empty answers"
  hideEmptyAnswers: "Nascondi risposte vuote",
  // "Show empty answers"
  showEmptyAnswers: "Mostra risposte vuote",
  // "All answers"
  "topNValueText-1": "Tutte le risposte",
  // "Top 5 answers"
  topNValueText5: "Top 5 risposte",
  // "Top 10 answers"
  topNValueText10: "Top 10 risposte",
  // "Top 20 answers"
  topNValueText20: "Top 20 risposte",
  // "Hide missing answers"
  hideMissingAnswers: "Nascondi le risposte mancanti",
  // "Show missing answers"
  showMissingAnswers: "Mostra le risposte mancanti",
  // "Missing answers"
  missingAnswersLabel: "Risposte mancanti",
  // "This question type is not visualized yet"
  noVisualizerForQuestion: "Questo tipo di domanda non è ancora stato visualizzato",
  // "There are no results yet"
  noResults: "Non ci sono ancora risultati",
  // "Per Values"
  showPerValues: "Per Valori",
  // "Per Columns"
  showPerColumns: "Per Colonne",
  // "Answer"
  answer: "Risposta",
  // "Correct answer: "
  correctAnswer: "Risposta esatta: ",
  // "Percent"
  percent: "Percentuale",
  // [Auto-translated] "Percentage"
  percentage: "Percentuale",
  // [Auto-translated] "Chart"
  statistics_chart: "Tabella",
  // "Responses"
  responses: "Risposte",
  // [Auto-translated] "NPS"
  visualizer_nps: "Rete nazionale di dati",
  // [Auto-translated] "Chart"
  visualizer_boolean: "Tabella",
  // [Auto-translated] "Table"
  visualizer_options: "Tavolo",
  // [Auto-translated] "NPS"
  npsScore: "Rete nazionale di dati",
  // [Auto-translated] "Promoters"
  npsPromoters: "Promotori",
  // [Auto-translated] "Passives"
  npsPassives: "Passivi",
  // [Auto-translated] "Detractors"
  npsDetractors: "Detrattori",
  // [Auto-translated] "Category (X Axis):"
  axisXSelectorTitle: "Categoria (asse X):",
  // [Auto-translated] "Legend (Series):"
  axisYSelectorTitle: "Leggenda (serie):",
  // [Auto-translated] "Segments:"
  axisXAlternativeSelectorTitle: "Segmenti:",
  // [Auto-translated] "Groups:"
  axisYAlternativeSelectorTitle: "Gruppi:",
  // [Auto-translated] "Not selected"
  notSelected: "Non selezionato",
  // [Auto-translated] "Default"
  intervalMode_default: "Default",
  // [Auto-translated] "Decades"
  intervalMode_decades: "Decenni",
  // [Auto-translated] "Years"
  intervalMode_years: "Anni",
  // [Auto-translated] "Quarters"
  intervalMode_quarters: "Quarti",
  // [Auto-translated] "Months"
  intervalMode_months: "Mesi",
  // [Auto-translated] "Days"
  intervalMode_days: "Giorni",
  // [Auto-translated] "Custom"
  intervalMode_custom: "Costume",
  // [Auto-translated] "Auto"
  intervalMode_auto: "Automatico",
  // [Auto-translated] "Intervals:"
  intervalModeTitle: "Intervalli:",
  // [Auto-translated] "Show individual values"
  noRunningTotals: "Mostra i singoli valori",
  // [Auto-translated] "Show running totals"
  runningTotals: "Mostra totali parziali",
  // [Auto-translated] "Compare periods"
  groupDateSeries: "Confronta i periodi",
  // [Auto-translated] "View timeline"
  ungroupDateSeries: "Visualizza la timeline",
  // [Auto-translated] "None"
  noneAggregateText: "Nessuno",
  // [Auto-translated] "Aggregate:"
  selectAggregateText: "Aggregato:",
  // [Auto-translated] "Year ends with"
  groupedYearsAxisTitle: "L'anno si chiude con"
};

setupLocale({ localeCode: "it", strings: italianStrings, nativeName: "Italiano" });